/**
 * Month-Year rounding logic:
 * - If day <= 15, show that month
 * - If day > 15, show next month
 */
export function formatMonthYear(dateStr) {
  if (!dateStr) return null;
  const d = new Date(dateStr + "T00:00:00");
  if (isNaN(d.getTime())) return null;

  let month = d.getMonth(); // 0-based
  let year = d.getFullYear();
  const day = d.getDate();

  if (day > 15) {
    month += 1;
    if (month > 11) {
      month = 0;
      year += 1;
    }
  }

  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${months[month]} ${year}`;
}

/**
 * Calculate Close date: Due Date + 4 months, then format as Month Year (rounded)
 */
export function calcCloseDate(dueDateStr) {
  if (!dueDateStr) return null;
  const d = new Date(dueDateStr + "T00:00:00");
  if (isNaN(d.getTime())) return null;

  // Add 4 months
  d.setMonth(d.getMonth() + 4);

  // Now apply the same month-year rounding
  let month = d.getMonth();
  let year = d.getFullYear();
  const day = d.getDate();

  if (day > 15) {
    month += 1;
    if (month > 11) {
      month = 0;
      year += 1;
    }
  }

  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${months[month]} ${year}`;
}

export function formatCurrency(val) {
  if (val == null) return "--";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(val);
}

export function formatPercent(val) {
  if (val == null) return "--";
  return `${val}%`;
}

/** Short money for headers: $118M, $27.7M, $950K, $820. */
export function formatShortMoney(val) {
  const v = Number(val) || 0;
  const a = Math.abs(v);
  const trim = (n, d) => n.toFixed(d).replace(/\.0$/, "");
  if (a >= 1e9) return `$${trim(v / 1e9, a >= 1e11 ? 0 : 1)}B`;
  if (a >= 1e6) return `$${trim(v / 1e6, a >= 1e8 ? 0 : 1)}M`;
  if (a >= 1e3) return `$${trim(v / 1e3, a >= 1e5 ? 0 : 1)}K`;
  return `$${Math.round(v)}`;
}
